import React, { useEffect, useMemo, useState } from "react";

import PageTitle from "../PageTitle";
import PageSearch from "../PageSearch";
import DialogBox from "../../components/dialog-box/DialogBox";
import EnhancedTable from "../table/Table";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { fetchFinances } from "../../redux/actions/FinanceActions";
import { displayDateFormart, isValidArr } from "../../utility/utils";
import { FinanceModel } from "../../models/FinanceModel";
import Loader from "../../components/loader/Loader";
import FinanceForm from "./FinanceForm";

export type Mode = "add" | "edit";

type iData = {
  id: number;
  name: string;
  description: string;
  createdDate: string;
  // status: string;
};

const FinanacePage = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<Mode>("add");
  const [editData, setEditData] = useState<FinanceModel>();
  const [rootData, setRootData] = useState<iData[]>([]);
  const [filteredData, setFilteredData] = useState<iData[]>([]);

  const finances = useAppSelector((state) => state.finance.all_Finances);
  const isFinancesFetching = useAppSelector(
    (state) => state.finance.isFinancesFetching
  );

  const columns = useMemo(() => {
    return [
      {
        id: "name",
        numeric: false,
        disablePadding: false,
        label: "Name",
      },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: "Description",
      },
      {
        id: "createdDate",
        numeric: false,
        disablePadding: false,
        label: "Created Date",
        width: 150,
      },
      // {
      //   id: "status",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "Status",
      // },
    ];
  }, []);

  //To fetch all Finances
  useEffect(() => {
    dispatch(fetchFinances());
  }, [dispatch]);

  useEffect(() => {
    setRootData(() =>
      finances.map((finance) => ({
        id: finance.fundingSourceId,
        name: finance.name,
        description: finance.description,
        createdDate: displayDateFormart(finance.createdDate),
        // status: finance.isActive ? "Active" : "Inactive",
      }))
    );
  }, [finances]);

  // To set filtered data on change root data
  useEffect(() => {
    setFilteredData(rootData);
  }, [rootData]);

  const handleEdit = (id: string | number) => {
    const editFinance = finances.find((rec) => rec.fundingSourceId === id);
    setMode("edit");
    setEditData(editFinance);
    setIsModalOpen(true);
  };

  const createHandler = () => {
    setMode("add");
    setEditData(undefined);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const searchHandler = (searchVal: string): void => {
    setFilteredData(() =>
      searchVal
        ? rootData.filter((info) =>
            Object.values(info).join("").toLowerCase().includes(searchVal)
          )
        : rootData
    );
  };

  return (
    <>
      {!isValidArr(finances) && isFinancesFetching ? <Loader /> : null}
      <PageTitle
        title="Funding Sources"
        btnText="Add Funding Source"
        onClick={createHandler}
      />
      <PageSearch
        placeholder="Search Funding Sources"
        searchHandler={searchHandler}
      />
      <EnhancedTable
        columns={columns}
        data={filteredData}
        handleEdit={handleEdit}
      />
      {isModalOpen && (
        <DialogBox
          isModalOpen={isModalOpen}
          modalTitle={
            mode === "add" ? "Create Funding Sources" : "Edit Funding Sources"
          }
          handleModalClose={handleModalClose}
        >
          <FinanceForm
            mode={mode}
            data={editData}
            handleModalClose={handleModalClose}
          />
        </DialogBox>
      )}
    </>
  );
};

export default FinanacePage;
